export default __webpack_public_path__ + "static/media/img-0297-zambia-premium-face.136d83a5.png";